<template>
  <div>
    <div class="card mb-2" v-for="circle in circles" :key="circle._id">
      <router-link :to="`/circle/${circle._id}`" class="card-body p-2" pointer >
        <div class="d-flex flex-row justify-content-start">
          <p class="align-self-center my-0 mr-3">
            <img
              v-if="circle.upload && circle.upload.path"
              class="rounded-circle"
              width="48"
              :src="circle.upload.path"
              alt
            />
            <img
              v-else
              class="rounded-circle"
              width="48"
              src="../../../assets/avatar-circle.png"
              alt
            />
          </p>
          <h5 class="align-self-center m-0">{{circle.title}}</h5>
        </div>
      </router-link>
    </div>

    <Intersect @enter="reachedEndOfCircles()">
      <span></span>
    </Intersect>
  </div>
</template>

<script>
import Intersect from "vue-intersect";
import DataHandlerService from "@/services/data";
import ContentService from "@/services/content";
import CircleService from "@/services/circle";

const content = new ContentService();
const data = new DataHandlerService();
const circleService = new CircleService();

export default {
  name: "CirclePublicList",
  props: ["publicCircles", "section", "setCircleTopics", "menuFor"],
  components: { Intersect },
  data() {
    return {
      limit: 10,
      page: 1,
      circles: null
    };
  },
  created() {
    const circles = this.$props.publicCircles;
    this.circles = circles;
  },
  methods: {
    reachedEndOfCircles() {
        circleService
        .getPublicCircles(this.limit, this.page + 1)
        .then(res => {
            this.page += 1;
            res.map(item => {
            if (!this.circles.find(f => f._id === item._id)) {
                this.circles.push(item);
            }
            });
        })
        .catch(err => {
            console.log(err);
        });
    }
  }
};
</script>

<style>
[pointer] {
    cursor: pointer;
}
</style>